import {
    Module
} from 'wrapper6';

export default class OpeningHours extends Module {

    ready(app) {

        const TARGET = document.querySelector('.opening-hours.show p');

        if (!TARGET) return;

        const data = {
            action: 'opening_hours',
        }

        jQuery.post(main_theme_objects.ajax_url, data,
            (response) => {
                if (response !== 0) {
                    TARGET.innerHTML = response.markup
                }
            }
        )

    }
}